/*
  Project: Knowledge Hub
  Author: James Barr
 */

import toggleElement from './modules/toggle-element';
import bannerImage from './modules/banner-image';
import stickyHeader from './modules/sticky-header';
import scrollTo from './modules/scroll-to';
import stickySidebar from './modules/sticky-sidebar';
import zoomImage from './modules/zoom-image';
import loadMoreSearchResults from './modules/load-more-search-results';
import tabs from './modules/tabs';

toggleElement();
bannerImage();
stickyHeader();
scrollTo();
stickySidebar();
zoomImage();
loadMoreSearchResults();
tabs();



// WEBPACK FOOTER //
// ./src/scripts/app.js